import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import VotePage from './VotePage';
import RankingPage from './RankingPage';
import UserValidationPage from './UserValidationPage';
import MainPage from './MainPage';
import LoginPage from './LoginPage';
import { Button, Container, Nav, Navbar } from 'react-bootstrap';
import Logo from '../src/assets/LOGOTIPO-GKM.png';
import NavbarPage from './NavbarPage';
import StatisticsPage from './StatisticsPage';

function MainRouter() {
  return (
    <>
        <NavbarPage/>
        <div className="page-content gradient-background">
            
                <Routes>
                    {/* Página principal <Route path="/" element={<MainPage/>} />*/}
                    <Route path="/" element={<UserValidationPage/>} />
                    <Route path="/login" element={<LoginPage/>} />
                    <Route path="/solicitar-verificacion" element={<App />} />          {/* Página principal */}
                    <Route path="/verify-email" element={<VotePage />} /> {/* Página de votación */}
                    <Route path="/ingreso" element={<UserValidationPage/>} /> {/* Nueva ruta */}
                    <Route path="/votar" element={<VotePage />} />
                    <Route path="/ranking" element={<RankingPage/>} /> {/* Nueva ruta para el ranking */}
                    <Route path="/statistics" element={<StatisticsPage/>} /> {/* Nueva ruta para el ranking */}
                </Routes>
          
        </div>
    </>

  );
}

export default MainRouter;
